import { apiCall } from '~/providers';
import {
  GetEnergyTrendsHistory,
  GetOverviewSummary, GetOverviewUnitHealth, GetUnitHealthHistory, OverviewInfo,
} from '../types';
import { WaterOverviewInfo } from 'providers/types/api-private';
import { verifyArrayParameters } from 'helpers/genericHelper';
import { HealthStatusOverviewFilter } from '~/providers/types/overview';

type FilterOptions = {
  stateIds?: string[];
  unitIds?: number[];
  healthStatus?: string;
}

export async function getOverviewInfo(
  clientId: number,
): Promise<OverviewInfo | undefined> {
  try {
    const response = await apiCall('/clients/get-overview-info', {
      CLIENT_ID: clientId,
    });

    return {
      hasWater: response.HAS_WATER_DEVICES,
      hasHealth: response.HAS_HEALTH_CONTROL,
      hasEnergy: response.HAS_ENERGY_DEVICES,
    };
  } catch (error) {
    console.log(error);
    return undefined;
  }
}

export async function getWaterOverviewInfo(
  clientId: number,
  filterOptions?: FilterOptions,
): Promise<WaterOverviewInfo | undefined> {
  try {
    const response = await apiCall('/water/get-overview-info', {
      CLIENT_ID: clientId,
      STATE_IDS: verifyArrayParameters(filterOptions?.stateIds),
      UNIT_IDS: verifyArrayParameters(filterOptions?.unitIds),
      HEALTH_STATUS: verifyArrayParameters(parseHealthStatus(filterOptions?.healthStatus)),
    });

    return response;
  } catch (error) {
    console.log(error);
    return undefined;
  }
}

export async function getOverviewSummary(
  clientId: number,
  filterOptions?: FilterOptions,
): Promise<GetOverviewSummary | undefined> {
  try {
    const response = await apiCall('/clients/get-overview-summary', {
      CLIENT_ID: clientId,
      STATE_IDS: verifyArrayParameters(filterOptions?.stateIds),
      UNIT_IDS: verifyArrayParameters(filterOptions?.unitIds),
      HEALTH_STATUS: verifyArrayParameters(parseHealthStatus(filterOptions?.healthStatus)),
    });

    return response;
  } catch (error) {
    console.log(error);
    return undefined;
  }
}

export async function getOverviewUnitHealth(
  clientId: number,
  filterOptions?: FilterOptions,
): Promise<GetOverviewUnitHealth | undefined> {
  try {
    const response = await apiCall('/unit-health/get-overview-info', {
      CLIENT_ID: clientId,
      STATE_IDS: verifyArrayParameters(filterOptions?.stateIds),
      UNIT_IDS: verifyArrayParameters(filterOptions?.unitIds),
      HEALTH_STATUS: verifyArrayParameters(parseHealthStatus(filterOptions?.healthStatus)),
    });

    return response;
  } catch (error) {
    console.log(error);
    return undefined;
  }
}

export async function getUnitHealthHistory(
  clientId: number,
  filterOptions?: FilterOptions,
): Promise<GetUnitHealthHistory | undefined> {
  try {
    const response = await apiCall('/unit-health/get-history', {
      CLIENT_ID: clientId,
      STATE_IDS: verifyArrayParameters(filterOptions?.stateIds),
      UNIT_IDS: verifyArrayParameters(filterOptions?.unitIds),
      HEALTH_STATUS: verifyArrayParameters(parseHealthStatus(filterOptions?.healthStatus)),
    });

    return response;
  } catch (error) {
    console.log(error);
    return undefined;
  }
}

export async function getEnergyTrendsHistory(
  clientId: number,
  filterOptions?: FilterOptions,
): Promise<GetEnergyTrendsHistory | undefined> {
  try {
    const response = await apiCall('/energy/get-trends-history', {
      CLIENT_ID: clientId,
      STATE_IDS: verifyArrayParameters(filterOptions?.stateIds),
      UNIT_IDS: verifyArrayParameters(filterOptions?.unitIds),
      HEALTH_STATUS: verifyArrayParameters(parseHealthStatus(filterOptions?.healthStatus)),
    });

    return response;
  } catch (error) {
    console.log(error);
    return undefined;
  }
}

function parseHealthStatus(healthStatus?: string): HealthStatusOverviewFilter[] | undefined {
  if (!healthStatus) return undefined;

  return [healthStatus as HealthStatusOverviewFilter];
}

// Santander = [21, 59, 120, 152]
// 88  - C&A
// 136 - Bradesco
// 145 - Banco do Brasil
// 153 - Cinemark
// 159 - Autozone
// 167 - Vulp Air
// 73  - Petz

export const allowClientsOverview = [21, 59, 88, 120, 136, 152, 145, 153, 159, 167, 73];
